module.exports = __webpack_public_path__ + "img/blog1.76251eb4.jpg";